export default {
  principal: {
    min: 0,
    max: 99999999,
    error: 'Please enter a value between 0 and 99,999,999',
    blank: 'This field cannot be blank'
  },

  interest: {
    min: 0,
    max: 99.99,
    error: 'Please enter a value between 0 and 99.99',
    blank: 'This field cannot be blank'
  },

  numberOfYears: {
    min: 1,
    max: 8901,
    error: 'Please enter a value between 1 and 8,901',
    blank: 'This field cannot be blank'
  }
}
